import { Colors } from '@brg/ui'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const LoadingPageWrapper = styled.div<any>`
    padding-top: 184px;

    font-family: Inter;
    font-size: 30px;
    font-weight: 400;
    line-height: 40px;
    letter-spacing: -0.02em;
    text-align: center;
    ${p => p.storageBg && `background: ${p.storageBg};`}
    height: 100%;

    color: ${p => p.theme.loading ? p.theme.loading : Colors.galBlack47};
`

const LoadingPage: FC<{redirecting?: boolean}> = ({redirecting}) => {
    const { t } = useTranslation()

  return (
    <LoadingPageWrapper storageBg={window.location.href.includes('/competition/')? '#525252' : undefined}>
        {redirecting ? "Redirecting..." : t("text.loading")}...
    </LoadingPageWrapper>
  )
}

export default LoadingPage
import { Colors } from '@brg/ui'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const LoadingPageWrapper = styled.div<any>`
    padding-top: 184px;

    font-family: Inter;
    font-size: 30px;
    font-weight: 400;
    line-height: 40px;
    letter-spacing: -0.02em;
    text-align: center;
    ${p => p.storageBg && `background: ${p.storageBg};`}
    height: 100%;

    color: ${p => p.theme.loading ? p.theme.loading : Colors.galBlack47};
`

const LoadingPage: FC<{redirecting?: boolean}> = ({redirecting}) => {
    const { t } = useTranslation()

  return (
    <LoadingPageWrapper storageBg={window.location.href.includes('/competition/')? '#525252' : undefined}>
        {redirecting ? "Redirecting..." : t("text.loading")}...
    </LoadingPageWrapper>
  )
}

export default LoadingPage
